import api from '../../api';
import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import NextLocalMatchForm from './NextLocalMatchForm';
import NextLocalMatchTable from './NextLocalMatchTable';

const NextLocalMatch = () => {
  const [nextLocalMatches, setNextLocalMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formDataNextLocalMatch, setFormDataNextLocalMatch] = useState({
    date: '',
    matchHours: '',
    departureBusHours: '',
    departurePlaceBus: '',
    arrivalPlaceBus: '',
        vsTeam: '',
    torneo: '',
  });

  const fetchNextLocalMatches = async () => {
    setLoading(true);
    try {
      const response = await api.get('/nextLocalMatches');
      setNextLocalMatches(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNextLocalMatches();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/nextLocalMatch/${id}`);
      fetchNextLocalMatches();
    } catch (error) {
      console.error('Error deleting local match:', error);
    }
  };

  const handleEdit = async (updatedMatch) => {
    try {
      await api.put(`/nextLocalMatch/${updatedMatch.id}`, updatedMatch);
      fetchNextLocalMatches();
    } catch (error) {
      console.error('Error editing local match:', error);
    }
  };

  const handleInputChangeNextLocalMatch = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormDataNextLocalMatch({
      ...formDataNextLocalMatch,
      [event.target.name]: value,
    });
  };

  const handleFormNextLocalMatchSubmit = async (event) => {
    event.preventDefault();
    await api.post('/nextLocalMatch', formDataNextLocalMatch);
    fetchNextLocalMatches();
    setFormDataNextLocalMatch({
      date: '',
      matchHours: '',
      departureBusHours: '',
      departurePlaceBus: '',
      arrivalPlaceBus: '',
            vsTeam: '',
      torneo: '',
    });
  };

  return (
    <div className="container">
      <NextLocalMatchForm
        formDataNextLocalMatch={formDataNextLocalMatch}
        onInputChange={handleInputChangeNextLocalMatch}
        onSubmit={handleFormNextLocalMatchSubmit}
      />
      <div style={{ height: '80px' }}></div>
      {loading ? <LoadingSpinner /> : (
        <NextLocalMatchTable
          nextLocalMatches={nextLocalMatches}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      )}
    </div>
  );
};

export default NextLocalMatch;
